import { render, staticRenderFns } from "./BM3001-dialog.vue?vue&type=template&id=4721a615&scoped=true"
import script from "./BM3001-dialog.vue?vue&type=script&lang=js"
export * from "./BM3001-dialog.vue?vue&type=script&lang=js"
import style0 from "./BM3001-dialog.vue?vue&type=style&index=0&id=4721a615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4721a615",
  null
  
)

export default component.exports